import {ReactElement} from 'react';
import {useCart, CartCost} from '@shopify/hydrogen';
import {useCartUI} from '../../hooks';
import classNames from 'classnames';

export default function CartMenuButton(): ReactElement {
  const {openCart} = useCartUI();
  const {totalQuantity} = useCart();

  return (
    <div
      role="button"
      tabIndex={-1}
      onClick={openCart}
      className={classNames('main-header__cart', {
        'main-header__cart--empty': !totalQuantity,
      })}
    >
      <div className="main-header__cart-button cart-preview-sidebar-js">
        <span className="main-header__cart-price">
          {totalQuantity && totalQuantity > 0 ? (
            <span>
              $
              <CartCost as="span" amountType="total" withoutCurrency />
            </span>
          ) : (
            'Your Cart'
          )}
        </span>
        <i className="icon-cart" />
        <span className="main-header__cart-items">{totalQuantity}</span>
      </div>
    </div>
  );
}
